import ModifyTeamBtnPresenter from "./ModifyTeamBtnPresenter";

const ModifyTeamBtn = ModifyTeamBtnPresenter;

export default ModifyTeamBtn;